import { graphql } from 'gatsby';

/**
 * === MAP COMMENTS WIDGET PROPS PARAMS ===============================================
 * @param {Object} props of the widget
 * @param {string} locale of the props
 * @returns {Object} widget definition
 */

export const mapCommentsWidgetProps = (props, locale) => {
  return {
    key: props?.key,
    comments:
      props?.comments?.map((comment) => {
        return {
          body: comment?.[`body_${locale}`] ?? '',
          rating: comment?.rating ?? 0,
          user: {
            firstName: comment?.userFirstName,
            lastName: comment?.userLastName,
            avatar: comment?.userAvatar?.childImageSharp?.fluid,
            city: comment?.userCity,
          },
        };
      }) ?? [],
  };
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment Commentcarousel on StrapiWidgetrels {
    commentcarousel {
      key: id
      comments {
        body_en
        body_es
        rating
        userFirstName
        userLastName
        userCity
        userAvatar {
          childImageSharp {
            fluid(maxWidth: 800, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      widgetPosition
    }
  }
`;
